
import React from 'react'
import { mdx } from '@mdx-js/react'
export const readingTime = {"text":"1 min read","minutes":0.825,"time":49500,"words":165}
/* @jsx mdx */
import before from './before.png'
import after from './after.png'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h2 {...{
      "id": "how-to-do-git-add-commit-and-push-in-one-command"
    }}>{`how to do git add commit and push in one command?`}</h2>
    <p>{`After putting your project in a remote repository, you find that you often want to push changes to that repository.
You typically do it with these three commands:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash",
        "data-language": "bash",
        "data-highlighted-line-numbers": "",
        "dangerouslySetInnerHTML": {
          "__html": "<span class=\"token function\">git</span> <span class=\"token function\">add</span> --all\n<span class=\"token function\">git</span> commit -m <span class=\"token string\">\"commit message\"</span>\n<span class=\"token function\">git</span> push -u origin master\n"
        }
      }}></code></pre>
    <p>{`Notice that it’s alot of typing, is there a way to make it quicker?`}</p>
    <p><strong parentName="p">{` How to do git add commit and push in one command: `}</strong></p>
    <ul>
      <li parentName="ul">{`open the file “.gitconfig” in your home directory.`}</li>
      <li parentName="ul">{`add the following to the file:`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-bash",
        "data-language": "bash",
        "data-highlighted-line-numbers": "",
        "dangerouslySetInnerHTML": {
          "__html": "<span class=\"token punctuation\">[</span>alias<span class=\"token punctuation\">]</span>\n    acp <span class=\"token operator\">=</span> <span class=\"token string\">\"!l() { git add --all &amp;&amp; git commit -m <span class=\"token entity\" title=\"\\&quot;\">\\\"</span>commit message<span class=\"token entity\" title=\"\\&quot;\">\\\"</span> &amp;&amp; git push -u origin master; }; l\"</span>\n\n"
        }
      }}></code></pre>
    <p><strong parentName="p">{`Before:`}</strong></p>
 <img style={{
      "maxWidth": "100%"
    }} src={before} /> 
    <p><strong parentName="p">{`After:`}</strong></p>
 <img style={{
      "maxWidth": "100%"
    }} src={after} /> 
    <h3 {...{
      "id": "and-now-you-can-call-them-like-the-following"
    }}>{`And now you can call them like the following:`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-bash",
        "data-language": "bash",
        "data-highlighted-line-numbers": "",
        "dangerouslySetInnerHTML": {
          "__html": "<span class=\"token function\">git</span> acp\n"
        }
      }}></code></pre>
    <p><strong parentName="p">{`Video Tutorial`}</strong>{`:`}</p>
    <iframe width="560" height="315" src="https://www.youtube.com/embed/r-sGqQpUDlQ" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
export const tableOfContents = (components={}) => [
  {
    id: "how-to-do-git-add-commit-and-push-in-one-command",
    level: 2,
    title: "how to do git add commit and push in one command?",
    children: [
        {
              id: "and-now-you-can-call-them-like-the-following",
              level: 3,
              title: "And now you can call them like the following:",
              children: [
                      
                    ]
            }
      ]
  }
]

export const frontMatter = {}

